import apiClient from './apiClient';

export interface TelegramLinkTokenResponse {
  token: string;
  link?: string;
  expiresAt: string;
}

type ApiEnvelope<T> = { success?: boolean; data?: T };

const unwrap = <T>(response: any): T => {
  const body = response?.data ?? response;
  const envelope = body as ApiEnvelope<T>;
  return envelope && Object.prototype.hasOwnProperty.call(envelope, 'data')
    ? (envelope.data as T)
    : (body as T);
};

class TelegramService {
  async createLinkToken(userId: string): Promise<TelegramLinkTokenResponse> {
    const response = await apiClient.post<ApiEnvelope<TelegramLinkTokenResponse>>(`/telegram/users/${userId}/link-token`);
    return unwrap<TelegramLinkTokenResponse>(response);
  }

  async setChatId(userId: string, chatId?: string | null): Promise<{ id: string; telegramChatId?: string | null; telegramLinkedAt?: string | null }> {
    const response = await apiClient.patch(`/telegram/users/${userId}/chat-id`, { chatId });
    return unwrap(response);
  }
}

export default new TelegramService();

